{
  "1 Task": "1 Task",
  "Add a note to your admin about why you want access to Call Intelligence. We'll send an email to them to start a free trial!": "Add a note to your admin about why you want access to Call Intelligence. We'll send an email to them to start a free trial!",
  "Analyzed Calls": "Analyzed Calls",
  "Appointment Type": "Appointment Type",
  "Appointment Type isn't analyzed for {{nonPatientToken}} calls.": "Appointment Type isn't analyzed for {{nonPatientToken}} calls.",
  "Beta": "Beta",
  "Call Analysis": "Call Analysis",
  "Call Categories": "Call Categories",
  "Call History": "Call History",
  "Call Intelligence": "Call Intelligence",
  "Calls": "Calls",
  "Calls are not analyzed if they have a single participant, very short audio, or audio exceeding an hour in length.": "Calls are not analyzed if they have a single participant, very short audio, or audio exceeding an hour in length.",
  "Cancel": "Cancel",
  "Catch trends over time": "Catch trends over time",
  "Category": "Category",
  "Click to view calls": "Click to view calls",
  "Contact Type": "Contact Type",
  "Couldn't fetch overview details. Please try again.": "Couldn't fetch overview details. Please try again.",
  "Couldn't fetch recent call. Please try again.": "Couldn't fetch recent call. Please try again.",
  "Couldn't load call list calls. Please try again.": "Couldn't load call list calls. Please try again.",
  "Customer Sentiment": "Customer Sentiment",
  "Customer Sentiment isn't analyzed for {{nonPatientToken}} calls.": "Customer Sentiment isn't analyzed for {{nonPatientToken}} calls.",
  "Dismiss": "Dismiss",
  "Free Trial of Call Intelligence": "Free Trial of Call Intelligence",
  "Get follow-up tasks": "Get follow-up tasks",
  "Jane Doe, an existing patient, called frustrated about a $191 charge for a preventive exam that her insurance should have covered. She deman...": "Jane Doe, an existing patient, called frustrated about a $191 charge for a preventive exam that her insurance should have covered. She deman...",
  "Know how the patient felt": "Know how the patient felt",
  "Last 12 Months": "Last 12 Months",
  "Last Call": "Last Call",
  "Last call was not analyzed. Review the call recording.": "Last call was not analyzed. Review the call recording.",
  "Mark as Recovered Opportunity": "Mark as Recovered Opportunity",
  "New": "New",
  "No Appointment Type discussed on the call.": "No Appointment Type discussed on the call.",
  "No Call Analysis Available": "No Call Analysis Available",
  "No Opportunity": "No Opportunity",
  "No Transcript Available": "No Transcript Available",
  "No data to display.": "No data to display.",
  "No data to display. You'll see patient insights here once Call Intelligence analyzes their calls.": "No data to display. You'll see patient insights here once Call Intelligence analyzes their calls.",
  "Opportunity": "Opportunity",
  "Please review the call recording.": "Please review the call recording.",
  "Processing phone call...": "Processing phone call...",
  "Processing phone call....": "Processing phone call....",
  "Request Call Intelligence": "Request Call Intelligence",
  "Request Upgrade": "Request Upgrade",
  "Save Changes": "Save Changes",
  "Scheduled": "Scheduled",
  "Scheduling Opportunity": "Scheduling Opportunity",
  "Scheduling Opportunity isn't analyzed for {{nonPatientToken}} calls.": "Scheduling Opportunity isn't analyzed for {{nonPatientToken}} calls.",
  "Scheduling Outcome": "Scheduling Outcome",
  "Scheduling Outcome isn't analyzed for {{nonPatientToken}} calls.": "Scheduling Outcome isn't analyzed for {{nonPatientToken}} calls.",
  "See call summaries": "See call summaries",
  "Service Issues": "Service Issues",
  "Skip digging through calls. Be ready for your next conversation with this patient.": "Skip digging through calls. Be ready for your next conversation with this patient.",
  "Start Free Trial": "Start Free Trial",
  "Successfully saved changes!": "Successfully saved changes!",
  "Summary": "Summary",
  "This AI-generated data may not always be accurate. Please review the Call Insights carefully.": "This AI-generated data may not always be accurate. Please review the Call Insights carefully.",
  "This feature is intended solely for Weave customers to correct AI outputs perceived as wrongly classified.": "This feature is intended solely for Weave customers to correct AI outputs perceived as wrongly classified.",
  "This may take a few minutes.": "This may take a few minutes.",
  "Transcript": "Transcript",
  "Unable to save changes. Please try again.": "Unable to save changes. Please try again.",
  "Unknown": "Unknown",
  "Unscheduled": "Unscheduled",
  "Update Status?": "Update Status?",
  "Updated Manually": "Updated Manually",
  "Updated by Call Intelligence": "Updated by Call Intelligence",
  "Updates were made by another user. Please refresh and try again.": "Updates were made by another user. Please refresh and try again.",
  "View Demo": "View Demo",
  "View History": "View History",
  "We are unable to transcribe and analyze this call. ": "We are unable to transcribe and analyze this call. ",
  "{{ taskCount }} Task": "{{ taskCount }} Task",
  "{{ taskCount }} Tasks": "{{ taskCount }} Tasks",
  "{{patientCapitalizedToken}} Call Trends": "{{patientCapitalizedToken}} Call Trends",
  "{{patientCapitalizedToken}} Call Trends are limited due to this location having less than a year of Call Intelligence data.": "{{patientCapitalizedToken}} Call Trends are limited due to this location having less than a year of Call Intelligence data.",
  "{{taskType}} Task": "{{taskType}} Task"
}
